import styled from 'styled-components'

const ControlButtonsWrapper = styled.div`
  flex-shrink: 0;
  position: relative;
  top: -2px;
`

export default ControlButtonsWrapper
